/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Tools_AbilitiesInputs */

const en_control_tools_abilities = /** @type {(inputs: Control_Tools_AbilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find the trade-offs that fit the way you play.`)
};

const zh_control_tools_abilities = /** @type {(inputs: Control_Tools_AbilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比较不同战斗能力适合的玩法，减少选错后的试错成本。`)
};

/**
* | output |
* | --- |
* | "Find the trade-offs that fit the way you play." |
*
* @param {Control_Tools_AbilitiesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_tools_abilities = /** @type {((inputs?: Control_Tools_AbilitiesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Tools_AbilitiesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_tools_abilities(inputs)
	return zh_control_tools_abilities(inputs)
});
export { control_tools_abilities as "control.tools.abilities" }